module.exports = __webpack_public_path__ + "48915f167c1f259a7db7dec924d3a903.pdf";